import { CreditService } from 'src/app/services/credit.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FilterTable } from 'src/app/models/filter-table';
import { Paging } from 'src/app/models/page';
import { PosListConfig } from '../pos-list/pos-list-config';
import { Param } from 'src/app/models/param';
import { OnBaseCatalogueType } from 'src/app/@core/constants';
import { Customer } from 'src/app/models/customer';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-pos-no-enter-credit-request-reason-modal',
  templateUrl: './pos-no-enter-credit-request-reason-modal.component.html',
  styleUrls: ['./pos-no-enter-credit-request-reason-modal.component.sass'],
})
export class PosNoEnterCreditRequestReasonModalComponent implements OnInit {
  @Input() customer: Customer | undefined;
  @Input() preApproveCode: string | undefined;
  @Output() isAValidReasonSelected = new EventEmitter<boolean>();

  public dataSource: Array<Param> = [];

  public selectedValue: string = '';

  public reasonForm = this.formBuilder.group({
    reasonCode: this.formBuilder.control(null, Validators.required),
    reasonDescription: this.formBuilder.control(null, Validators.required),
  });

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private readonly onbaseService: OnbaseService,
    private readonly creditService: CreditService,
    private readonly configurationService: ConfigurationService
  ) {}

  async ngOnInit(): Promise<void> {
    this.dataSource = await this.onbaseService
      .readOnBaseCatalogueObject(
        OnBaseCatalogueType.REASON_NO_ENTER_CREDIT_REQUEST
      )
      .toPromise();
  }

  cancel() {
    this.bsModalRef.hide();
    this.isAValidReasonSelected.emit(false);
    this.isAValidReasonSelected.complete();
  }

  async confirm(): Promise<void> {
    this.bsModalRef.hide();

    const customerCode = this.customer?.code;
    const branchCode =
      this.configurationService.readSelectedBranchAndSalesOrg().branch.code;
    const reasonCode = this.reasonForm.get('reasonCode')?.value;
    const reasonName = this.reasonForm.get('reasonDescription')?.value;
    let response = true;

    if (this.preApproveCode && this.preApproveCode !== '') {
      const responseService = await this.creditService
        .saveNoEnterCreditRequestReasonForPreApprove({
          preApproveCode: this.preApproveCode,
          reasonCode,
          reasonName,
        })
        .toPromise()
        .catch((error) => {
          this.isAValidReasonSelected.emit(true);
          this.isAValidReasonSelected.complete();
          throw error;
        });

      response = responseService.response;
    } else {
      const responseService = await this.creditService
        .saveNoEnterCreditRequestReason({
          customerCode,
          branchCode,
          reasonCode,
          reasonName,
        })
        .toPromise()
        .catch((error) => {
          this.isAValidReasonSelected.emit(true);
          this.isAValidReasonSelected.complete();
          throw error;
        });

      response = responseService.response;
    }

    this.isAValidReasonSelected.emit(response);
    this.isAValidReasonSelected.complete();
  }

  changeType() {
    console.log(this.reasonForm.value);
    this.reasonForm.patchValue({
      reasonDescription: this.dataSource.filter(
        (reason) => reason.code === this.reasonForm.get('reasonCode')?.value
      )[0].value,
    });
  }
}
